import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: wrap;
  justify-content: space-around;
`;
